:host {
  display: block;
}
.textarea {
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  font-family: var(--sc-input-font-family);
  font-weight: var(--sc-input-font-weight);
  line-height: var(--sc-line-height-normal);
  letter-spacing: var(--sc-input-letter-spacing);
  vertical-align: middle;
  transition: var(--sc-input-transition, var(--sc-transition-medium)) color, var(--sc-input-transition, var(--sc-transition-medium)) border, var(--sc-input-transition, var(--sc-transition-medium)) box-shadow,
    var(--sc-input-transition, var(--sc-transition-medium)) background-color;
  cursor: text;
}
/* Standard textareas */
.textarea--standard {
  background-color: var(--sc-input-background-color);
  border: solid var(--sc-input-border-width) var(--sc-input-border-color);
}
.textarea--standard:hover:not(.textarea--disabled) {
  background-color: var(--sc-input-background-color-hover);
  border-color: var(--sc-input-border-color-hover);
}
.textarea--standard:hover:not(.textarea--disabled) .textarea__control {
  color: var(--sc-input-color-hover);
}
.textarea--standard.textarea--focused:not(.textarea--disabled) {
  background-color: var(--sc-input-background-color-focus);
  border-color: var(--sc-input-border-color-focus);
  color: var(--sc-input-color-focus);
  box-shadow: 0 0 0 var(--sc-focus-ring-width) var(--sc-input-focus-ring-color);
}
.textarea--standard.textarea--focused:not(.textarea--disabled) .textarea__control {
  color: var(--sc-input-color-focus);
}
.textarea--standard.textarea--disabled {
  background-color: var(--sc-input-background-color-disabled);
  border-color: var(--sc-input-border-color-disabled);
  opacity: 0.5;
  cursor: not-allowed;
}
.textarea--standard.textarea--disabled .textarea__control {
  color: var(--sc-input-color-disabled);
}
.textarea--standard.textarea--disabled .textarea__control::placeholder {
  color: var(--sc-input-placeholder-color-disabled);
}
/* Filled textareas */
.textarea--filled {
  border: none;
  background-color: var(--sc-input-filled-background-color);
  color: var(--sc-input-color);
}
.textarea--filled:hover:not(.textarea--disabled) {
  background-color: var(--sc-input-filled-background-color-hover);
}
.textarea--filled.textarea--focused:not(.textarea--disabled) {
  background-color: var(--sc-input-filled-background-color-focus);
  outline: var(--sc-focus-ring);
  outline-offset: var(--sc-focus-ring-offset);
}
.textarea--filled.textarea--disabled {
  background-color: var(--sc-input-filled-background-color-disabled);
  opacity: 0.5;
  cursor: not-allowed;
}
.textarea__control {
  flex: 1 1 auto;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: 1.4;
  color: var(--sc-input-color);
  border: none;
  background: none;
  box-shadow: none;
  cursor: inherit;
  -webkit-appearance: none;
}
.textarea__control::-webkit-search-decoration,
.textarea__control::-webkit-search-cancel-button,
.textarea__control::-webkit-search-results-button,
.textarea__control::-webkit-search-results-decoration {
  -webkit-appearance: none;
}
.textarea__control::placeholder {
  color: var(--sc-input-placeholder-color);
  user-select: none;
}
.textarea__control:focus {
  outline: none;
}
/*
 * Size modifiers
 */
.textarea--small {
  border-radius: var(--sc-input-border-radius-small);
  font-size: var(--sc-input-font-size-small);
}
.textarea--small .textarea__control {
  padding: 0.5em var(--sc-input-spacing-small);
}
.textarea--medium {
  border-radius: var(--sc-input-border-radius-medium);
  font-size: var(--sc-input-font-size-medium);
}
.textarea--medium .textarea__control {
  padding: 0.5em var(--sc-input-spacing-medium);
}
.textarea--large {
  border-radius: var(--sc-input-border-radius-large);
  font-size: var(--sc-input-font-size-large);
}
.textarea--large .textarea__control {
  padding: 0.5em var(--sc-input-spacing-large);
}
/*
 * Resize types
 */
.textarea--resize-none .textarea__control {
  resize: none;
}
.textarea--resize-vertical .textarea__control {
  resize: vertical;
}
.textarea--resize-auto .textarea__control {
  height: auto;
  resize: none;
}

.textarea__char-limit-warning{
  margin-top: var(--sc-input-spacing-small);
  color: var(--sc-input-help-text-color);
  font-size: var(--sc-input-help-text-font-size-medium);
}
